"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
/*eslint-disable*/const messages = {
  'Add "{inputValue}"': ['Agregar "', ["inputValue"], '"'],
  "All items have been removed.": "Se eliminaron todos los elementos.",
  "Clear selection": "Borrar selección",
  "No results found.": "No se encontraron resultados.",
  "Press Enter to select or deselect an option.": "Presione Intro para seleccionar una opción o anular la selección.",
  "Select All": "Seleccionar todo",
  "Selected Items": "Elementos seleccionados",
  "Toggle menu": "Alternar menú",
  "listbox contents": "contenido del cuadro de lista",
  "{itemAsString} has been removed.": ["Se ha eliminado ", ["itemAsString"], "."],
  "{itemAsString} has been selected.": ["Se ha seleccionado ", ["itemAsString"], "."],
  "{resultCount, plural, one {# result is} other {# results are}} available, use up and down arrow keys to navigate. Press Enter key to select.": [["resultCount", "plural", {
    one: ["#", " resultado está disponible"],
    other: ["#", " resultados están"]
  }], " disponibles, use las flechas hacia arriba y hacia abajo para desplazarse. Presione la tecla Enter para seleccionar."],
  "{selectedValue} selected": [["selectedValue"], " seleccionado"],
  "{totalSelectedItems} selected": [["totalSelectedItems"], " seleccionados"],
  "{totalSelectedItems} selected. Deselect all": [["totalSelectedItems"], " seleccionados. Cancelar la selección de todo"],
  "{totalSelectedItems} selected. Select all {totalOptions} items": [["totalSelectedItems"], " seleccionados. Seleccionar los ", ["totalOptions"], " elementos"]
};
exports.messages = messages;
//# sourceMappingURL=messages.js.map